import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import PdpSharedDetailMeasurement from './helpers/PdpSharedDetailMeasurement';

// helpers
import get from 'lodash.get';

function PdpSharedDetailShoulderToHem({ item }) {
    const shoulderToHem = get(item, 'measurement.shoulderToHem');

    if (!shoulderToHem) {
        return null;
    }

    return (
        <PdpSharedDetailMeasurement
            dataTn="pdp-spec-shoulder-to-hem"
            measurements={shoulderToHem}
        />
    );
}

PdpSharedDetailShoulderToHem.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailShoulderToHem, {
    item: graphql`
        fragment PdpSharedDetailShoulderToHem_item on Item {
            measurement {
                shoulderToHem: display(fields: [shoulderToHem]) {
                    ...PdpSharedDetailMeasurement_measurements
                }
            }
        }
    `,
});
